<template>
    <div class="box">
    	<div class="container-fluid">
	        <div class="mb-3">
	            <button class="btn btn-primary" @click="scan">
	                <template v-if="scanning">
	                    <font-awesome-icon :icon="['fal', 'spinner']" spin /> {{ $t('global.bluetooth_active') }}
	                </template>
	                <template v-else>
	                    {{ $t('global.activer_bleutooth') }}
	                </template>
	            </button>
	        </div>

	        <textarea class="w-100 form-control" rows="5" v-model="transpondeurs" :placeholder="getTrad('horse.transpondeur_par_ligne')"></textarea>
	        
	        <div class="text-center mt-3">
	            <button class="btn btn-primary" @click="get_horse">
	                <font-awesome-icon v-if="loading" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['far', 'plus']" /> {{ $t('global.ajouter') }}
	            </button>
	        </div>
	    </div>
    </div>
</template>

<script type="text/javascript">
import HorseMixin from "@/mixins/Horse.js"
import BluetoothMixin from "@/mixins/Bluetooth.js"

export default {
    name: "Microship",
    mixins: [HorseMixin, BluetoothMixin],
    data() {
        return {
            transpondeurs: '',
            loading: false
        }
    },

    computed: {
        /** @returns {boolean} Alias pour bluetoothScanning du mixin */
        scanning() {
            return this.bluetoothScanning
        }
    },

    methods: {
        /**
         * Traite les données reçues via Bluetooth (caractéristique BLE).
         * Extrait les numéros de transpondeur au format XXX XXXXXXXXXXXX.
         * @param {Event} event - Événement characteristicvaluechanged
         */
        onBluetoothCharacteristicChange(event) {
            const transponder = this.parseBluetoothTransponder(event)
            if (transponder) {
                const new_line = '\r\n'
                let temp = this.transpondeurs.trim() + new_line + transponder
                this.transpondeurs = temp.trim() + new_line
            }
        },

        /**
         * Démarre ou arrête le scan Bluetooth pour les lecteurs de transpondeurs.
         */
        scan() {
            this.scanBluetooth()
        },
        async get_horse() {
            if(!this.loading) {
                this.loading = true
                const transpondeurs = this.transpondeurs.split(/\r\n|\n|\r/);
                if(transpondeurs.length > 50) {
                    this.failureToast("toast.transpondeur_nb_error")
                    this.loading = false
                    return
                }
                this.transpondeurs = this.transpondeurs.replaceAll(' ', '')
                const result = await this.addHorseByTranspondeur(this.transpondeurs)
                if(!result) {
                    this.failureToast("toast.info_save_failed")
                    this.loading = false
                    return
                }

                const errors = result.retour.errors
                if(errors.length > 0) {
                    this.failureToast(this.getTrad("toast.add_horse_transpondeur_error") + ' ' + errors.join(', '))
                    const ids = result.retour.ids
                    if(ids.length > 0) {
                        await this.$sync.force() 
                        this.$router.push({ name: 'postImportHorseList', params: { horse_ids: ids }})
                    }
                    this.loading = false
                    return
                }
                
                this.successToast("toast.info_save_succes")
                
                const ids = result.retour.ids
                if(ids.length > 0) {
                    await this.$sync.force() 
                    this.$router.push({ name: 'postImportHorseList', params: { horse_ids: ids }})
                }
                this.loading = false
            }
        }
    },
    components: {
        HeaderTab: () => import('@/components/HeaderTab')
    }
}
</script>